import React from 'react';
import { IonButton } from '@ionic/react';
import { useServiceWorker } from '../contexts/useServiceWorker';

export function UpgradePrompt() {
    const { hasPendingUpdate, applyUpdate } = useServiceWorker();

    if (!hasPendingUpdate) {
        return null;
    }

    return (
        <div className="upgradeBanner ion-text-center">
            <p>A new version of PMS is available! <br />Tap reload to upgrade now.</p>
            <IonButton
                onClick={ applyUpdate }
                color='white'
                size='small'
            >
                Reload
            </IonButton>
        </div>
    );
}
